<script module>
	import type { NotificationType } from '@src/types/notification.d.ts';

	export interface RfNotificationCentreProps {
		notifications: NotificationType[];
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { removeNotification } from '@store/notification-centre.svelte';
	let { notifications } = $props();
</script>

<div class="notifications-centre">
	{#each notifications as notif}
		<div class={classNames('notification', `notification--${notif.severity}`)} role="alert">
			<div class="notification__content">
				<h5 class="notification__title">{notif.title}</h5>
				<p class="notification__message">{notif.message}</p>
			</div>
			{#if notif.dismissable && notif.id}
				<button class="notification__dismiss" onclick={() => removeNotification(notif.id as string)}>Dismiss</button>
			{/if}
		</div>
	{/each}
</div>

<style lang="scss">
	.notifications-centre {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}
	.notification {
		box-sizing: border-box;
		padding: 12px 10px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		flex-grow: 1;
		gap: 24px;
		width: 100%;
		&__message,
		&__title {
			margin: 0;
			font-family: sans-serif;
		}
		&__title {
			font-size: 16px;
		}
		&__message {
			font-size: 14px;
		}
		&__content {
			display: flex;
			flex-direction: column;
			gap: 8px;
		}
		&--info {
			.notification__title {
				color: var(--rf-info-color, #3d2cff);
			}
			border: 2px solid var(--rf-info-color, #3d2cff);
			background-color: #cbc6ff;
		}
		&--error {
			.notification__title {
				color: var(--rf-error-color, #ff4a4a);
			}
			border: 2px solid var(--rf-error-color, #ff4a4a);
			background-color: #fcbcbc;
		}
		&--warning {
			.notification__title {
				color: var(--rf-warning-color, #ffcc00);
			}
			border: 2px solid var(--rf-warning-color, #ffcc00);
			background-color: #fefad8;
		}
		&--success {
			.notification__title {
				color: var(--rf-success-color, #2ee42e);
			}
			border: 2px solid var(--rf-success-color, #2ee42e);
			background-color: #d9f9d9;
		}

		&__dismiss {
			all: unset;
			width: 30px;
			height: 30px;
			background: transparent;
			font-size: 0;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			&::before,
			&::after {
				position: absolute;
				content: '';
				display: block;
				width: 20px;
				height: 2px;
				background-color: var(--rf-primary-font-color, #333);
				cursor: pointer;
			}
			&::before {
				transform: rotate(45deg);
			}
			&::after {
				transform: rotate(-45deg);
			}
		}
	}
</style>
